module.exports = __webpack_public_path__ + "img/404.c8a099db.svg";